import { mapState, mapGetters } from 'vuex'
import sessionHistorySushi from '@/components/session-history-sushi/session-history-sushi.vue';
import productHistorySushi from '@/components/product-history-sushi/product-history-sushi.vue';
import watchlistSushi from '@/components/watchlist-sushi/watchlist-sushi.vue';
import sushiMarketLinksToggle from '../../components/sushi-market-links-toggle/sushi-market-links-toggle.vue';

export default {
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showWatchlist: false,
      isWatchlistLoading: false,
    };
  },
  components: {
    sessionHistorySushi,
    productHistorySushi,
    watchlistSushi,
    sushiMarketLinksToggle
  },
  computed: {
    ...mapGetters('app', ['isPinningEnabled']),
    ...mapState('market', ['market', 'sessionHistory']),
    ...mapState('watchlist', ['watchlist']),
    isWatchlistEmpty() {
      return this.watchlist.data === null ? true : this.watchlist.data.length === 0;
    },
    isSessionHistoryEmpty() {
      return this.sessionHistory.length === 0;
    },
  },
  watch: {
    isActive: {
      handler(isActive) {
        if (isActive && !this.showWatchlist) {
          this.showWatchlist = true;
        } else {
          this.showWatchlist = false; // necessary show it reloads when coming back
        }
      },
      immediate: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/page-market-detail-sushi/pages/sushi-market-links/sushi-market-links.js